<template>
  <div
    :class="{
      'format-container': true,
      'crop-mode': getEditor.cropMode && getActiveElement.type == 'main'
    }"
  >
    <div v-show="getEditor.marginView" class="imageEditorCanvas">
      <img class="imageFromCanvas" :src="getCanvasImage" />
    </div>
    <div
      v-show="getEditor.marginView && !getHasFrame"
      :class="{
        layerH: isHor,
        layerV: isVer,
        layerR: isRou,
        marginViewPlaceHolder: true
      }"
      :style="[getMarginViewStyle, getMarginViewBg]"
    >
      <div
        v-show="getMirrored"
        :style="getMirroredTopStyle"
        class="topMirrored mirroredDiv"
      ></div>
      <div
        v-show="getMirrored"
        :style="getMirroredRightStyle"
        class="rightMirrored mirroredDiv"
      ></div>
      <div
        v-show="getMirrored"
        :style="getMirroredBottomStyle"
        class="bottomMirrored mirroredDiv"
      ></div>
      <div
        v-show="getMirrored"
        :style="getMirroredLeftStyle"
        class="leftMirrored mirroredDiv"
      ></div>
      <div
        v-show="getRandOption"
        :style="getMarginTopStyle"
        class="topMarginDiv marginDiv"
      >
        {{ $t("Rand") }}
      </div>
      <div
        v-show="getRandOption"
        :style="getMarginRightStyle"
        class="rightMarginDiv marginDiv"
      >
        <span>{{ $t("Rand") }}</span>
      </div>
      <div
        v-show="getRandOption"
        :style="getMarginBottomStyle"
        class="bottomMarginDiv marginDiv"
      >
        {{ $t("Rand") }}
      </div>
      <div
        v-show="getRandOption"
        :style="getMarginLeftStyle"
        class="leftMarginDiv marginDiv"
      >
        <span>{{ $t("Rand") }}</span>
      </div>
      <div
        class="leftMarginDiv marginDiv marginWhiteDiv"
        :style="getMarginLeftStyleWhite"
      ></div>
      <div
        class="bottomMarginDiv marginDiv marginWhiteDiv"
        :style="getMarginBottomStyleWhite"
      ></div>
      <div
        class="RightMarginDiv marginDiv marginWhiteDiv"
        :style="getMarginRightStyleWhite"
      ></div>
      <div
        class="toptMarginDiv marginDiv marginWhiteDiv"
        :style="getMarginTopStyleWhite"
      ></div>
    </div>
    <!-- drop -->
    <div
      v-show="(getEditor.marginView && !getHasFrame) || !getEditor.marginView"
      class="drop"
      :class="[{ dropMargin: getEditor.marginView && getHasFrame, drop: 1 }]"
      @drop="handleDrop($event)"
      @dragenter.prevent
      @dragover.prevent
    >
      <div
        v-show="getEditor.marginView && !getHasFrame"
        class="shadowContainer"
        :style="[getStyle, getBackgroundStyle]"
      ></div>
      <div
        v-show="getFormat.show"
        id="format-layer"
        ref="formatLayer"
        :class="{ layerH: isHor, layerV: isVer, layerR: isRou }"
        :style="[getStyle, getBackgroundStyle]"
      >
        <div
          id="format-crop-layer"
          :class="{ layerR: isRou }"
          :style="getCropStyle"
        >
          <div v-if="getMargin.rand_option" id="format-layer-dashed"></div>
          <appWallpaperLines></appWallpaperLines>
          <appCornersFormat></appCornersFormat>
          <appLayerEditor :type="'steckdosen'"></appLayerEditor>
          <appLayerEditor :type="'cutouts'"></appLayerEditor>
          <appLayerEditor :type="'objects'"></appLayerEditor>
          <div v-if="!getFormat.rounded" class="formatInfo formatW">
            {{ getFormat.width }} {{ $t("cm") }}
          </div>
          <div class="formatInfo formatH">
            {{ getFormat.height }}{{ $t("cm") }}
          </div>
        </div>
        <u></u>
        <u class="whiteB"></u>
      </div>
    </div>
    <!-- drop -->
    <div v-show="getEditor.marginView" class="marginViewDummyPlaceHolder"></div>
  </div>
</template>
<script>
import { useImageEditorStore } from "@/stores/modules/imageEditor";
import { useEditorFilesStore } from "@/stores/modules/editorFiles";
import { useWebproductStore } from "@/stores/modules/webproduct";
import { mapState, mapActions } from "pinia";

//import { Drop } from "vue-drag-drop";

import WallpaperLines from "../imageEditor/WallpaperLines";
import CornersFormat from "../imageEditor/CornersFormat";
import LayerEditor from "../imageEditor/LayerEditor";

export default {
  props: ["dosen"],
  components: {
    //  drop: Drop,
    appWallpaperLines: WallpaperLines,
    appCornersFormat: CornersFormat,
    appLayerEditor: LayerEditor
  },
  computed: {
    ...mapState(useImageEditorStore, [
      "getFormat",
      "getImage",
      "getFullFormatDim",
      "getMargin",
      "getReady",
      "getFullMargins",
      "getEditor",
      "canvasFormatDimByFormat",
      "getBckMode",
      "getCanvasImage",
      "getActiveElement",
      "getEnableWhiteMargin",
      "pdfUnit"
    ]),
    ...mapState(useWebproductStore, ["getHasFrameOptions"]),
    focalPoint: function () {
      return this.getEditor.focalPoint;
    },
    getHasFrame: function () {
      return this.getHasFrameOptions.hasFrame;
    },
    getLeftStyle: function () {
      if (this.getEnableWhiteMargin && 0) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        return {
          left: size.whiteleft + "px"
        };
      }
      return {
        left: "1px"
      };
    },
    getTopStyle: function () {
      if (this.getEnableWhiteMargin && 0) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        return {
          top: size.whiteleft + "px"
        };
      }
      return {
        top: "1px"
      };
    },
    zoom: function () {
      return this.getEditor.zoom;
    },
    originalImage: function () {
      return this.getImage.original;
    },
    fullFormat: function () {
      return this.getFullFormatDim;
    },
    fullMargins: function () {
      return this.getFullMargins;
    },
    format: function () {
      return this.getFormat;
    },
    margins: function () {
      return this.getMargin;
    },
    thickness: function () {
      return this.getThickness.thickness;
    },
    isHor: function () {
      return this.format.type == 1;
    },
    isVer: function () {
      return this.format.type == 2;
    },
    isRou: function () {
      return this.format.rounded == 1;
    },
    image: function () {
      return this.getImage;
    },
    getMarginViewStyle: function () {
      if (this.getReady) {
        var size = this.canvasFormatDimByFormat;
        var result = {
          width: Math.round(size.width) + "px",
          height: Math.round(size.height) + "px",
          top: Math.round(size.top) + "px",
          left: Math.round(size.left) + "px"
        };
        return result;
      }
      return {};
    },
    getMarginValue: function () {
      var margin = 6;
      var size = this.getEditor.dim.canvasImageDimByFormat;
      var size1 = this.canvasFormatDimByFormat;
      var finalHeight = globalStore.state.imageEditor.format.height;
      var height = size1.height - size.top - size.bottom;
      return (margin * height) / finalHeight;
    },
    getMarginFrameStyle: function () {
      if (this.getReady) {
        var size = this.canvasFormatDimByFormat;
        var marginValue = this.getMarginValue;
        var result = {
          width: Math.round(size.width + marginValue * 2) + "px",
          height: Math.round(size.height + marginValue * 2) + "px",
          top: Math.round(size.top - marginValue) + "px",
          left: Math.round(size.left - marginValue) + "px"
        };
        return result;
      }
      return {};
    },
    getMarginViewBg: function () {
      if (this.margins.type < 0) {
        return {
          "background-color": "rgba(0,0,0,0)"
        };
      }
      return {
        "background-color": "#fff"
      };
    },

    getFrameBck: function () {
      return {
        "background-image": "url(" + this.getCanvasImage + ")"
      };
    },
    getStyle: function () {
      if (this.getReady) {
        var size = this.canvasFormatDimByFormat;
        var result = {
          width: Math.round(size.width) + "px",
          height: Math.round(size.height) + "px",
          top: Math.round(size.top) + "px",
          left: Math.round(size.left) + "px"
        };
        return result;
      }
      return {};
    },
    getBackgroundStyle: function () {
      if (this.getReady) {
        var result = {};
        if (this.margins.type < 0) {
          //enlarged
          result["background"] = "none";
        } else {
          if (this.margins.subtype == 1) {
            // mirrored
            result["background"] = "none";
          }
          if (this.getEditor.marginView) {
            if (this.margins.subtype == 2) {
              // white
              result["background"] = this.margins.color;
            }
            if (this.margins.subtype == 3) {
              // monochrome
              result["background"] = this.margins.color;
            }
          }
        }
        return result;
      }
      return {};
    },
    getCropStyle: function () {
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size.left + size1.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size.top + size1.top)) *
          -1;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var result = {
          width: width + "px",
          height: height + "px",
          top: size.top - 1 + "px",
          left: size.left - 1 + "px",
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
        return result;
      }
      return {};
    },
    getMirrored: function () {
      return this.margins.type == 1 && this.margins.subtype == 1;
    },
    getRandOption: function () {
      return this.margins.rand_option == 1 && this.margins.rand_option == 1;
    },
    getMirroredTopStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: width + "px",
          height: size.top + "px",
          left: size.left + "px",
          top: "0px",
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginTopStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var font = 16;
        if (size.top < 12) {
          font = size.top;
        }
        result = {
          height: size.top + "px",
          "line-height": size.top + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMirroredBottomStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);
        var bottom = size1.height - height - size.top;
        var bg_left = -1 * size1.left;
        var bg_top = -1 * (height + size1.top - bottom);
        bg_top = Math.round(bg_top - (zoomH - size.height) / 2);
        bg_left = Math.round(bg_left - (zoomW - size.width) / 2);
        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (height + size1.top + size.top - bottom)) *
          -1;
        result = {
          width: width + "px",
          height: bottom + "px",
          left: size.left + "px",
          bottom: "0px",
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginBottomStyleWhite: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.whiteleft - size.whiteright;
        var height = size1.height - size.whitetop - size.whitebottom;
        var bottom = size1.height - height - size.whitetop;
        var font = 16;
        if (size.whitetop < 12) {
          font = size.whitebottom;
        }
        result = {
          height: bottom + "px",
          "line-height": bottom + "px",
          left: "0px",
          bottom: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMarginBottomStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var bottom = size1.height - height - size.top;
        var font = 16;
        if (size.top < 12) {
          font = size.bottom;
        }
        result = {
          height: bottom + "px",
          "line-height": bottom + "px",
          left: "0px",
          bottom: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMirroredLeftStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (size1.left + size.left)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: size.left + "px",
          height: height + "px",
          left: "0px",
          top: size.top + "px",
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginLeftStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        //var size1     = this.calculateFormatDim ();
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var font = 16;

        if (size.left < 12) {
          font = size.left;
        }
        result = {
          width: size.left + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMarginLeftStyleWhite: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        //var size1     = this.calculateFormatDim ();
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.whiteleft - size.whiteright;
        var height = size1.height - size.whitetop - size.whitebottom;
        var font = 16;

        if (size.whiteleft < 12) {
          font = size.whiteleft;
        }
        result = {
          width: size.whiteleft + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },

    getMirroredRightStyle: function () {
      var result = [];
      if (this.getReady) {
        var editorCanvasByFormat = this.getEditor.dim.canvasDimByFormat;
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var zoom = this.zoom / 100;
        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var zoomW = Math.round(size.width * zoom);
        var zoomH = Math.round(size.height * zoom);
        var right = size1.width - width - size.left;

        var bg_left =
          (Math.round(
            this.focalPoint.x * zoom - editorCanvasByFormat.width / 2
          ) +
            (width + size1.left + size.left - right)) *
          -1;
        var bg_top =
          (Math.round(
            this.focalPoint.y * zoom - editorCanvasByFormat.height / 2
          ) +
            (size1.top + size.top)) *
          -1;

        result = {
          width: right + "px",
          height: height + "px",
          right: "0px",
          top: size.top + "px",
          "background-image": "url('" + this.getImage.resized.src + "')",
          "background-size": zoomW + "px " + zoomH + "px",
          "background-position": bg_left + "px " + bg_top + "px"
        };
      }
      return result;
    },
    getMarginRightStyle: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.left - size.right;
        var height = size1.height - size.top - size.bottom;
        var right = size1.width - width - size.left;
        var font = 16;
        if (right < 12) {
          font = right;
        }

        result = {
          width: right + "px",
          right: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    getMarginRightStyleWhite: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;

        var width = size1.width - size.whiteleft - size.whiteright;
        var height = size1.height - size.whitetop - size.whitebottom;
        var right = size1.width - width - size.whiteleft;
        var font = 16;
        if (right < 12) {
          font = right;
        }

        result = {
          width: right + "px",
          right: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    },
    unit: function () {
      return (
        this.getEditor.dim.imageDimByFormat.unit /
        this.getEditor.dim.canvasDimByFormat.unit
      );
    },
    formatChanges: function () {
      return this.fullFormat;
    },
    getMarginTopStyleWhite: function () {
      var result = [];
      if (this.getReady) {
        var size = this.getEditor.dim.canvasImageDimByFormat;
        var size1 = this.canvasFormatDimByFormat;
        var width = size1.width - size.whiteleft - size.whiteright;
        var height = size1.height - size.whitetop - size.whitebottom;
        var font = 16;
        if (size.whitetop < 12) {
          font = size.whitetop;
        }
        result = {
          height: size.whitetop + "px",
          "line-height": size.whitetop + "px",
          left: "0px",
          top: "0px",
          "font-size": font + "px"
        };
      }
      return result;
    }
  },
  methods: {
    ...mapActions(useImageEditorStore, [
      "getResizedImageAction",
      "checkItemPosition"
    ]),
    handleDrop(event) {
      const type = event.dataTransfer.getData("type");
      const id = event.dataTransfer.getData("id");
      if (type && id) {
        const { pageX, pageY } = event;
        const el = this.$refs.formatLayer;
        const $el = jQuery(this.$refs.formatLayer);
        const offset = $el.offset();
        const unit = this.unit;
        let top = pageY - offset.top;
        let left = pageX - offset.left;

        switch (type) {
          case "local_image":
            if ($el.width() < left + 100) left = $el.width() - 100;
            if ($el.height() < top + 100) top = $el.height() - 100;

            if (top < 0) top = 0;
            if (left < 0) left = 0;

            const background = this.getBckMode | 0;

            const dataToSend = {
              uuid: id,
              left: left / unit,
              top: ($el.height() - top) / unit,
              background: background
            };

            this.getResizedImageAction(dataToSend);

            break;
        }
      }
    }
  },
  watch: {
    formatChanges: {
      handler: function () {
        this.$nextTick(() => {
          this.checkItemPosition({});
        });
      },
      deep: false
    }
  }
};
</script>
